import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp, faGoogle } from '@fortawesome/free-brands-svg-icons';
import { Link } from 'react-router-dom';


import styled from './Contactanos.module.css';

const Contactanos = () => {
  return (
    <div className={styled.div}>
      <Link to='/'>
        <button className={styled.button}>
          Regresar al inicio
        </button>
      </Link>
      <Link className={styled.a} to="https://api.whatsapp.com/send?phone=584245048417">
        <FontAwesomeIcon icon={faWhatsapp} className={styled.icon} />
        WhatsApp
      </Link>
      <Link className={styled.a} to="https://goo.gl/maps/SyWMhaTbjkN4keph7">
        <FontAwesomeIcon icon={faGoogle} className={styled.icon} />
        Ubicanos
      </Link>

    </div>
  );
};

export default Contactanos;
